// libraries.
import { useState } from "react";

// store.
import { useUserProfile } from "@shared/GoogleLoginButton/user-slice/useUserProfile.hook";
import { useRulesSlice } from "@store/apiSlices/incentiveRules/slices/rules";

// styles.
import { StyledSinClasificarPanel } from "../styles";

// interfaces.
import { RawRuleItem } from "@store/apiSlices/incentiveRules/interfaces/rawRules.interfaces";

// components.
import { RulePanelRow } from "./RulePanelRow";
import { ConfirmToggleModal } from "./ConfirmToggleModal";
import { CreateRuleModal } from "./CreateRuleModal";

// ─── Component ────────────────────────────────────────────────────────────────

export const SinClasificarPanel = () => {
  const { country, email } = useUserProfile();
  const resolvedCountry = country || "CO";
  const { getRawRulesForCountry, toggleRule } = useRulesSlice();

  // Reglas sin sub_ruta_id asignada o con state_route inválido (null / 0).
  const unclassified = getRawRulesForCountry(resolvedCountry).filter(
    (r) => r.sub_ruta_id === null || r.state_route === null || r.state_route === 0,
  );
  const sorted = [...unclassified].sort((a, b) => a.rule.priority - b.rule.priority);

  // ── Modal: Toggle ───────────────────────────────────────────────────────────
  const [toggleTarget, setToggleTarget] = useState<RawRuleItem | null>(null);

  const handleToggleConfirm = async () => {
    if (!toggleTarget) return;
    await toggleRule(toggleTarget, resolvedCountry, email ?? "");
    setToggleTarget(null);
  };

  // ── Modal: Editar ───────────────────────────────────────────────────────────
  const [editTarget, setEditTarget] = useState<RawRuleItem | null>(null);

  return (
    <>
      <StyledSinClasificarPanel>
        <div className="sinclasificar-panel">
          <div className="sinclasificar-header">
            <span className="boxing-label label--sinclasificar">📋 Sin clasificar</span>
            <p className="sinclasificar-subtitle">
              Estas reglas no tienen sub-ruta ni tipo asignado. Éditalas para clasificarlas.
            </p>
            <span className="panel-count count--sinclasificar">
              {sorted.length} regla{sorted.length !== 1 ? "s" : ""}
            </span>
          </div>

          <div className="sinclasificar-body">
            {sorted.length === 0 ? (
              <p className="panel-empty">Todas las reglas están clasificadas. ✅</p>
            ) : (
              sorted.map((rule) => (
                <RulePanelRow
                  key={rule.rule_id}
                  rule={rule}
                  variant="winner"
                  onEdit={(r) => setEditTarget(r)}
                  onToggle={(r) => setToggleTarget(r)}
                />
              ))
            )}
          </div>
        </div>
      </StyledSinClasificarPanel>

      <ConfirmToggleModal
        rawRule={toggleTarget}
        onConfirm={handleToggleConfirm}
        onClose={() => setToggleTarget(null)}
      />

      {editTarget && (
        <CreateRuleModal
          show={!!editTarget}
          country={resolvedCountry}
          subRutaId={editTarget.sub_ruta_id ?? 0}
          stateRoute={
            editTarget.state_route === 1 || editTarget.state_route === 2
              ? editTarget.state_route
              : 1
          }
          editRule={editTarget}
          onClose={() => setEditTarget(null)}
        />
      )}
    </>
  );
};
